// Mock data for ARIHANT SALES fabric products

export const fabricCategories = [
  {
    id: 'stretch-zurich',
    name: 'Stretch & Zurich Fabrics',
    icon: 'Layers'
  },
  {
    id: 'sportswear',
    name: 'Sportswear & Performance',
    icon: 'Zap'
  },
  {
    id: 'hosiery',
    name: 'Hosiery / Knit / Lower',
    icon: 'Package'
  },
  {
    id: 'fashion',
    name: 'Fashion & Cotton',
    icon: 'Sparkles'
  },
  {
    id: 'accessory',
    name: 'Accessory Materials',
    icon: 'Package2'
  }
];

export const fabricProducts = [
  // Stretch & Zurich Fabrics
  {
    id: 1,
    name: '2-Way Zurich Fabric',
    category: 'stretch-zurich',
    description: 'High-quality 2-way stretch fabric for comfortable wear. Available in all colors.',
    image: 'https://customer-assets.emergentagent.com/job_arihant-sales/artifacts/6ccpo3bz_image.png',
    alt: '2-Way Zurich Fabric wholesale Jabalpur India',
    gsm: null,
    featured: true
  },
  {
    id: 2,
    name: '4-Way Zurich Fabric',
    category: 'stretch-zurich',
    description: 'Premium 4-way stretch fabric - Available in 220 GSM & 260 GSM. All colors available.',
    image: 'https://customer-assets.emergentagent.com/job_arihant-sales/artifacts/jhlzehjy_image.png',
    alt: '4-Way Zurich Fabric 220-260 GSM wholesale MP',
    gsm: '220 GSM, 260 GSM',
    featured: true
  },
  {
    id: 3,
    name: 'Imported Cotton Twill',
    category: 'stretch-zurich',
    description: 'Premium imported cotton twill - Available in Navy, Olive, Khakhi, Tan, D.Pista, M.Grey, D.Grey, Coffee & more',
    image: 'https://customer-assets.emergentagent.com/job_arihant-sales/artifacts/sptvc7zs_image.png',
    alt: 'Imported Cotton Twill Fabric supplier Madhya Pradesh',
    gsm: null,
    featured: true
  },
  {
    id: 4,
    name: 'Twill Denim',
    category: 'stretch-zurich',
    description: 'Premium quality twill denim - 230 GSM. Available in As Green, Olive, L Grey, D Grey, M Grey, Navy & all colors',
    image: 'https://customer-assets.emergentagent.com/job_arihant-sales/artifacts/92pw4oq5_WhatsApp%20Image%202026-01-25%20at%2018.50.37.jpeg',
    alt: 'Twill Denim Fabric 230 GSM wholesale Jabalpur',
    gsm: '230 GSM',
    featured: true
  },
  {
    id: 5,
    name: '2-Way Twill Fabric (Non-Spandex)',
    category: 'stretch-zurich',
    description: 'Classic twill fabric without spandex. Multiple colors available.',
    image: '/images/products/twill_2way_non_spandex.png',
    alt: '2-Way Twill Fabric Non-Spandex wholesale India',
    gsm: null,
    featured: false
  },
  {
    id: 6,
    name: '4-Way Twill Fabric (With Spandex)',
    category: 'stretch-zurich',
    description: 'Stretchable twill fabric with spandex. All colors in stock.',
    image: '/images/products/twill_4way_spandex.png',
    alt: '4-Way Twill Fabric with Spandex supplier MP',
    gsm: null,
    featured: false
  },


  // Sportswear & Performance Fabrics
  {
    id: 7,
    name: 'Superpoly Fabric',
    category: 'sportswear',
    description: 'Lightweight sportswear fabric - Available in 220 GSM & 260 GSM. All colors available.',
    image: 'https://customer-assets.emergentagent.com/job_arihant-sales/artifacts/ax8iwugj_superpoly.jpg',
    alt: 'Superpoly Sportswear Fabric wholesale Jabalpur',
    gsm: '220 GSM, 260 GSM',
    featured: true
  },
  {
    id: 8,
    name: 'Honeycomb Fabric',
    category: 'sportswear',
    description: 'Breathable honeycomb texture fabric. Available in multiple colors.',
    image: 'https://customer-assets.emergentagent.com/job_arihant-sales/artifacts/5aw115qv_honeycomb.jpg',
    alt: 'Honeycomb Texture Sportswear Fabric supplier India',
    gsm: null,
    featured: true
  },
  {
    id: 9,
    name: 'Micro PP Fabric (For T-Shirts)',
    category: 'sportswear',
    description: 'Lightweight micro polyester. All colors available.',
    image: '/images/products/micro_pp_tshirt_fabric.png',
    alt: 'Micro PP Fabric for T-shirts wholesale Jabalpur',
    gsm: null,
    featured: false
  },
  {
    id: 10,
    name: 'Dot Knit Fabric (For T-Shirts)',
    category: 'sportswear',
    description: 'Textured dot knit for t-shirts. Multiple color options.',
    image: '/images/products/dot_knit_tshirt_fabric.png',
    alt: 'Dot Knit Fabric for T-shirt manufacturing',
    gsm: null,
    featured: false
  },
  {
    id: 11,
    name: 'NS Fabric – 8% Spandex',
    category: 'sportswear',
    description: 'Performance fabric with 8% spandex. Available in all colors.',
    image: 'https://customer-assets.emergentagent.com/job_arihant-sales/artifacts/ksn4v9vl_NS%20LYCRA.jpg',
    alt: 'NS Lycra Fabric 8% Spandex wholesale MP',
    gsm: null,
    featured: false
  },
  {
    id: 12,
    name: 'NS Terry Fabric',
    category: 'sportswear',
    description: 'Soft terry fabric for sportswear. All colors in stock.',
    image: '/images/products/ns_terry_sportswear_fabric.png',
    alt: 'NS Terry Fabric for Sportswear wholesale India',
    gsm: null,
    featured: false
  },
  {
    id: 13,
    name: '2-Way Printed Fabric (For Lowers)',
    category: 'sportswear',
    description: 'Printed stretch fabric for lower garments',
    image: '/images/products/printed_2way_lower_fabric.png',
    alt: '2-Way Printed Fabric for lowers wholesale Jabalpur',
    gsm: null,
    featured: false
  },

  // Hosiery / Knit / Lower Fabrics
  {
    id: 14,
    name: 'P Knit Fabric (For Lowers)',
    category: 'hosiery',
    description: 'Comfortable knit fabric for lower garments. All colors available.',
    image: 'https://customer-assets.emergentagent.com/job_arihant-sales/artifacts/3fxerqqe_hosireys.jpg',
    alt: 'P Knit Fabric for Lower Garments wholesale Jabalpur',
    gsm: null,
    featured: true
  },
  {
    id: 15,
    name: 'P Knit Checks Fabric (For Lowers)',
    category: 'hosiery',
    description: 'Checkered pattern knit fabric. Multiple colors.',
    image: '/images/products/p_knit_checks_fabric.png',
    alt: 'P Knit Checks Fabric for lowers supplier MP',
    gsm: null,
    featured: false
  },
  {
    id: 16,
    name: 'Karara Fabric',
    category: 'hosiery',
    description: 'Crisp karara fabric for traditional wear. All colors available.',
    image: '/images/products/karara_fabric.png',
    alt: 'Karara Fabric for traditional wear wholesale India',
    gsm: null,
    featured: false
  },
  {
    id: 17,
    name: 'Twill Fabric',
    category: 'hosiery',
    description: 'Classic twill weave fabric. All colors in stock.',
    image: 'https://customer-assets.emergentagent.com/job_arihant-sales/artifacts/5lndvnn0_tricaot.jpg',
    alt: 'Classic Twill Weave Fabric wholesale Jabalpur',
    gsm: null,
    featured: false
  },
  {
    id: 18,
    name: 'Non-Spandex Tintin Fabric',
    category: 'hosiery',
    description: 'Standard tintin fabric without stretch. Multiple colors available.',
    image: '/images/products/non_spandex_tintin_fabric.png',
    alt: 'Non-Spandex Tintin Fabric for trousers wholesale',
    gsm: null,
    featured: false
  },
  {
    id: 19,
    name: 'Dori Tintin Fabric',
    category: 'hosiery',
    description: 'Textured dori tintin - Available in 220 GSM & 270 GSM. All colors in stock.',
    image: 'https://customer-assets.emergentagent.com/job_arihant-sales/artifacts/92pw4oq5_WhatsApp%20Image%202026-01-25%20at%2018.50.37.jpeg',
    alt: 'Dori Tintin Fabric 220-270 GSM supplier India',
    gsm: '220 GSM, 270 GSM',
    featured: false
  },
  {
    id: 21,
    name: '4-Way Twill Fabric',
    category: 'hosiery',
    description: 'Stretchable twill fabric. All colors in stock.',
    image: 'https://customer-assets.emergentagent.com/job_arihant-sales/artifacts/ax8iwugj_superpoly.jpg',
    alt: 'Stretchable 4-Way Twill Fabric wholesale Jabalpur',
    gsm: null,
    featured: false
  },

  // Fashion & Cotton Fabrics
  {
    id: 20,
    name: 'Zigzag Fabric – Matte Finish',
    category: 'fashion',
    description: 'Multi-colour digital print for girls pants. Available in all colors.',
    image: 'https://customer-assets.emergentagent.com/job_arihant-sales/artifacts/mbad75hl_image.png',
    alt: 'Zigzag Digital Print Fabric for girls pants wholesale',
    gsm: null,
    featured: true
  },
  {
    id: 22,
    name: 'Viscose and More Fashion Fabrics',
    category: 'fashion',
    description: 'Soft, breathable viscose fabric in various prints and colors. We offer many more premium fashion and cotton fabrics. Contact us for the full collection.',
    image: '/images/products/viscose_fabric.jpg',
    alt: 'Viscose Rayon Fashion Fabric wholesale Jabalpur',
    gsm: null,
    featured: false
  }
];

export const accessoryItems = [
  'Packing Polythene (All sizes)',
  'Elastic Bands (All inch sizes)',
  'Threads & Nadas (Drawstrings)',
  'Chain Rolls & Locks',
  'All Types of Patti (Tapes & Trims)',
  'Buttons and Fasteners',
  'Zippers (All sizes)',
  'Labels and Tags'
];

export const trustStats = [
  {
    number: '20+',
    label: 'Years in Business',
    icon: 'Award'
  },
  {
    number: '100+',
    label: 'Happy Customers',
    icon: 'Users'
  },
  {
    number: '30+',
    label: 'Fabric Varieties',
    icon: 'Package'
  },
  {
    number: '100%',
    label: 'Quality Guaranteed',
    icon: 'Shield'
  }
];

export const whyChooseUs = [
  {
    title: 'Biggest Fabric Wholesaler in Jabalpur',
    description: 'Largest fabric inventory with immediate availability and retail options available',
    icon: 'Building2'
  },
  {
    title: 'Lowest Wholesale Prices',
    description: 'Direct sourcing ensures best market prices for bulk orders',
    icon: 'TrendingDown'
  },
  {
    title: 'All Colors Available',
    description: 'We offer all fabric colors in rolls - from basic to premium shades',
    icon: 'ShoppingCart'
  },
  {
    title: 'Wide Distribution Network',
    description: 'Supplying to nearby cities and regions',
    icon: 'Truck'
  },
  {
    title: 'Trusted by Manufacturers',
    description: 'Preferred supplier for garment manufacturers and sportswear brands',
    icon: 'BadgeCheck'
  },
  {
    title: 'Quality Fabrics',
    description: 'Premium quality fabrics for all applications',
    icon: 'Star'
  }
];

export const howToOrderSteps = [
  {
    step: 1,
    title: 'Contact Us',
    description: 'Call or WhatsApp us with your fabric requirements',
    icon: 'Phone'
  },
  {
    step: 2,
    title: 'Get Quote',
    description: 'Receive competitive pricing and availability details',
    icon: 'FileText'
  },
  {
    step: 3,
    title: 'Place Order',
    description: 'Confirm your order and arrange delivery or pickup',
    icon: 'CheckCircle'
  }
];

export const contactInfo = {
  owner: 'Jinendra Kumar Jain',
  phone: '919713889720',
  whatsapp: '919713889720',
  address: {
    line1: '606, Garha Phatak',
    line2: 'In front of Badi Mahakali Mandir',
    line3: 'Main Road, Jabalpur',
    pincode: '482002',
    state: 'Madhya Pradesh',
    country: 'India'
  },
  businessHours: [
    { day: 'Monday', time: '11:00 AM - 9:00 PM' },
    { day: 'Tuesday', time: 'Closed', closed: true },
    { day: 'Wednesday', time: '11:00 AM - 9:00 PM' },
    { day: 'Thursday', time: '11:00 AM - 9:00 PM' },
    { day: 'Friday', time: '11:00 AM - 9:00 PM' },
    { day: 'Saturday', time: '11:00 AM - 9:00 PM' },
    { day: 'Sunday', time: '11:00 AM - 9:00 PM' }
  ],
  mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3667.123!2d79.9283883!3d23.1744563!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3981af98c4391d95%3A0xc4d71c1da3d62510!2sArihant%20Sales%20Dj!5e0!3m2!1sen!2sin!4v1234567890'
};

export const seoKeywords = [
  // Location-based permutations
  'Fabric wholesaler in Jabalpur',
  'Fabric wholesaler Jabalpur',
  'Wholesale fabric supplier in Jabalpur',
  'Wholesale fabric supplier Jabalpur',
  'Fabric shop in Jabalpur',
  'Fabric wholesaler in Madhya Pradesh',
  'Fabric wholesaler Madhya Pradesh',
  'Fabric wholesaler in MP',
  'Fabric wholesaler MP',
  'Wholesale fabric supplier in Madhya Pradesh',
  'Wholesale fabric supplier Madhya Pradesh',
  'Wholesale fabric supplier in MP',
  'Wholesale fabric supplier MP',
  'Fabric wholesaler in India',
  'Wholesale fabric supplier India',
  'Fabric wholesaler North India',
  'Wholesale fabric supplier North India',

  // Product + Location permutations
  'Sportswear fabric wholesaler Jabalpur',
  'Sportswear fabric wholesaler Madhya Pradesh',
  'Sportswear fabric wholesaler MP',
  'Sportswear fabric wholesaler India',
  'Hosiery fabric supplier Jabalpur',
  'Hosiery fabric supplier Madhya Pradesh',
  'Hosiery fabric supplier MP',
  'Hosiery fabric supplier India',
  'Superpoly fabric wholesaler Jabalpur',
  'Superpoly fabric wholesaler Madhya Pradesh',
  'Superpoly fabric wholesaler MP',
  'Superpoly fabric wholesaler India',
  'Zurich fabric wholesaler Jabalpur',
  'Zurich fabric wholesaler Madhya Pradesh',
  'Zurich fabric wholesaler MP',
  '4-way stretch fabric wholesaler Jabalpur',
  '4-way stretch fabric wholesaler Madhya Pradesh',
  '4-way stretch fabric wholesaler MP',
  '2-way fabric supplier Jabalpur',
  '2-way fabric supplier Madhya Pradesh',
  '2-way fabric supplier MP',
  'Honeycomb fabric supplier Jabalpur',
  'Honeycomb fabric supplier Madhya Pradesh',
  'Honeycomb fabric supplier MP',
  'Knit fabric wholesaler Jabalpur',
  'Knit fabric wholesaler Madhya Pradesh',
  'Knit fabric wholesaler MP',

  // Business type + Location permutations
  'Garment fabric supplier in Madhya Pradesh',
  'Garment fabric supplier Madhya Pradesh',
  'Garment fabric supplier MP',
  'Garment fabric supplier Jabalpur',
  'Textile wholesaler Jabalpur',
  'Textile wholesaler Madhya Pradesh',
  'Textile wholesaler MP',
  'Textile wholesaler India',
  'Bulk fabric supplier Jabalpur',
  'Bulk fabric supplier Madhya Pradesh',
  'Bulk fabric supplier MP',
  'Bulk fabric supplier India',
  'B2B fabric supplier Jabalpur',
  'B2B fabric supplier Madhya Pradesh',
  'B2B fabric supplier MP',
  'B2B fabric supplier India',

  // Market + Location permutations
  'Jabalpur fabric market',
  'Wholesale fabric market Madhya Pradesh',
  'Wholesale fabric market MP',
  'Jabalpur largest cloth market',
  'Fabric stores in Jabalpur',
  'Wholesale cloth Jabalpur',
  'Best fabric shop Jabalpur',
  'Wholesale fabric in Jabalpur price',
  'Fabric rolls Jabalpur',

  // Specific location permutations
  'Fabric supplier near Garha Phatak',
  'Wholesale fabric shop near Badi Mahakali Mandir',
  'Fabric in Madhya Pradesh',
  'Fabric in MP',

  // Product-specific variations
  'Superpoly fabrics for t-shirts',
  'Wholesale viscose fabric Jabalpur',
  'Best cotton fabric wholesaler Madhya Pradesh',
  'Best cotton fabric wholesaler MP',

  // Brand + Location
  'Arihant Sales Jabalpur fabrics',
  'Arihant Sales Madhya Pradesh',
  'Arihant Sales MP',

  // Additional high-value permutations
  'Wholesale textile supplier India',
  'Fabric manufacturer distributor Madhya Pradesh',
  'Fabric manufacturer distributor MP',
  'Wholesale sportswear material Madhya Pradesh',
  'Wholesale sportswear material MP',
  'Textile distributor Madhya Pradesh',
  'Textile distributor MP',
  'Export quality fabric Madhya Pradesh wholesale',
  'Export quality fabric MP wholesale'
];

// GSM Guide Data - High SEO Value for Technical Searches
export const gsmGuide = {
  title: "GSM Guide - Choose the Right Fabric Weight",
  description: "GSM (Grams per Square Meter) determines fabric weight and thickness. Higher GSM = thicker, more durable fabric.",
  ranges: [
    {
      gsm: "160-180 GSM",
      name: "Lightweight",
      uses: "T-shirts, summer wear, inner layers",
      fabrics: "Micro PP, Dot Knit, Light Superpoly",
      keywords: "160 GSM fabric wholesale, 180 GSM fabric supplier, lightweight fabric for t-shirts"
    },
    {
      gsm: "200-220 GSM",
      name: "Medium Weight",
      uses: "Track pants, casual lowers, sportswear",
      fabrics: "Superpoly 220 GSM, 4-Way Zurich 220 GSM, Hosiery",
      keywords: "220 GSM fabric wholesale India, 220 GSM superpoly fabric, fabric for track pants manufacturing"
    },
    {
      gsm: "230-260 GSM",
      name: "Heavy Weight",
      uses: "Winter wear, gym wear, premium sportswear",
      fabrics: "Superpoly 260 GSM, 4-Way Zurich 260 GSM, Twill Denim 230 GSM",
      keywords: "260 GSM fabric wholesale, 240 GSM fabric supplier, heavy fabric for gym wear"
    }
  ],
  cta: "Need help choosing GSM? Contact us for bulk orders and samples."
};

// Use-Case FAQ Data - Targets "fabric for X" searches
export const useCaseFAQ = [
  {
    question: "Which fabric is best for t-shirt manufacturing?",
    answer: "For t-shirts, we recommend 160-180 GSM Micro PP or Dot Knit fabric. These are lightweight, breathable, and ideal for bulk t-shirt production. Available in all colors.",
    keywords: "fabric for t-shirt manufacturing, t-shirt fabric wholesale, micro polyester fabric for t-shirts"
  },
  {
    question: "Which fabric should I use for track pants and lowers?",
    answer: "220 GSM Superpoly or 4-Way Zurich fabric works best for track pants and lowers. The 4-way stretch provides comfort and durability. Perfect for sportswear manufacturers.",
    keywords: "fabric for track pants, fabric for lowers manufacturing, sportswear fabric wholesale"
  },
  {
    question: "What's the best fabric for gym wear and activewear?",
    answer: "260 GSM 4-Way Zurich or Superpoly fabric is ideal for gym wear. The high GSM provides durability, while 4-way stretch ensures flexibility during workouts. Moisture-wicking properties available.",
    keywords: "fabric for gym wear, activewear fabric wholesale, performance fabric supplier India"
  },
  {
    question: "Which fabric is recommended for school uniforms?",
    answer: "For school uniforms, we recommend P Knit fabric or Cotton blends. These are durable, comfortable, and easy to maintain. Available in bulk quantities for uniform manufacturers.",
    keywords: "fabric for school uniforms, uniform fabric wholesale, bulk fabric for schools"
  },
  {
    question: "What fabric do you recommend for sportswear and jerseys?",
    answer: "Superpoly 220-260 GSM, Honeycomb fabric, or NS Fabric with 8% Spandex are excellent for sportswear and jerseys. They offer breathability, stretch, and moisture management.",
    keywords: "fabric for sports jerseys, sportswear fabric wholesale India, performance fabric for athletes"
  },
  {
    question: "Which fabric is best for yoga wear and athleisure?",
    answer: "4-Way Zurich 260 GSM with spandex is perfect for yoga wear. The 4-way stretch allows full range of motion, and the fabric is soft against skin. Ideal for athleisure brands.",
    keywords: "fabric for yoga wear, athleisure fabric wholesale, stretch fabric for yoga pants"
  },
  {
    question: "What fabric composition do you offer for sportswear?",
    answer: "We offer Polyester-Spandex blends (92% Polyester, 8% Spandex), 100% Polyester Superpoly, and Cotton-Poly blends. All fabrics available in bulk for garment manufacturers.",
    keywords: "polyester spandex fabric wholesale, 92 polyester 8 spandex fabric, fabric composition for sportswear"
  },
  {
    question: "Do you supply fabric for corporate uniforms and workwear?",
    answer: "Yes, we supply Twill Denim 230 GSM, Cotton Twill, and P Knit fabric - all ideal for corporate uniforms and workwear. Durable, professional appearance, available in bulk.",
    keywords: "fabric for corporate uniforms, workwear fabric wholesale, bulk fabric for companies"
  }
];

// Trade/B2B Keywords for Footer Enhancement
export const tradeSEOKeywords = [
  // Trade/B2B Intent
  'fabric wholesale dealer India',
  'fabric bulk supplier India',
  'fabric roll supplier India',
  'fabric for garment manufacturing',
  'fabric supplier for factories',
  'fabric sourcing India',
  'fabric distributor for brands',
  'fabric supplier for exporters',
  'fabric for private label clothing',

  // Technical/Composition
  '220 GSM fabric wholesale India',
  '260 GSM fabric supplier',
  '240 GSM fabric wholesale',
  'polyester fabric wholesale India',
  'poly spandex fabric wholesale',
  '92 polyester 8 spandex fabric',
  'lycra fabric wholesale India',
  'viscose fabric wholesaler',
  'performance fabric supplier India',

  // Use-Case Based
  'fabric for t-shirt manufacturing',
  'fabric for track pants wholesale',
  'fabric for gym wear supplier',
  'fabric for sportswear manufacturing',
  'fabric for school uniforms bulk',
  'fabric for corporate uniforms',
  'fabric for activewear brands',
  'fabric for yoga wear wholesale'
];
